import { evolve, mapToObj, } from 'remeda';
import { assertDefined, deepTransform, } from './ObjectUtils.js';
export function trimToNull(value) {
    if (value === null || value === undefined) {
        return value;
    }
    const trimmedValue = value.trim();
    if (trimmedValue === '') {
        return null;
    }
    return trimmedValue;
}
export function trimToNullObject(obj, keys) {
    const keysEvolver = mapToObj(keys, key => [key, (v) => (typeof v === 'string' ? trimToNull(v) : v)]);
    return evolve(obj, keysEvolver);
}
export function trimToNullRecursively(obj) {
    return deepTransform(obj, o => (typeof o === 'string' ? trimToNull(o) : o));
}
export function partitionWords(input) {
    const maxLineLength = 45;
    const minLineLength = 18;
    const words = input.split(/\s+/);
    const lines = [[]];
    // first pass, split up to maxLineLength
    for (let i = 0; i < words.length; i++) {
        // istanbul ignore next
        const currentLine = lines[lines.length - 1] ?? [];
        const currentLineLength = currentLine.join(' ').length;
        // istanbul ignore next
        const word = words[i] ?? '';
        if (currentLineLength + 1 + word.length <= maxLineLength) {
            lines[lines.length - 1] = [...currentLine, word];
        }
        else {
            lines.push([word]);
        }
    }
    // second pass, check if the last line is too short
    if (lines.length > 1) {
        for (let i = 0; i < 10 - 1; i++) {
            // istanbul ignore next
            const lastLine = [...lines[lines.length - 1] ?? []];
            if (lastLine.join(' ').length >= minLineLength) {
                // the last line meets the expectation, so exit
                break;
            }
            // istanbul ignore next
            const beforeLastLine = [...lines[lines.length - 2] ?? []];
            // move the last word of the before last line to the beginning of the last line
            const lastWordOfBeforeLastLine = beforeLastLine.pop();
            assertDefined(lastWordOfBeforeLastLine);
            lastLine.unshift(lastWordOfBeforeLastLine);
            const lastLineLength = lastLine.join(' ').length;
            const beforeLastLineLength = beforeLastLine.join(' ').length;
            if (beforeLastLineLength < minLineLength) {
                // the before last line is now too short, so stop there without action
                break;
            }
            // istanbul ignore if
            if (lastLineLength >= maxLineLength) {
                // the last line is now too long, so stop there without action
                break;
            }
            // save result and continue
            lines[lines.length - 1] = lastLine;
            lines[lines.length - 2] = beforeLastLine;
        }
    }
    return lines.map(line => line.join(' ')).join('\n');
}
export function wrapLines(text, max) {
    const result = [];
    for (let line of text.replace(/\r\n?/g, '\n').split('\n')) {
        while (line.length > max) {
            const space = Math.max(line.lastIndexOf(' ', max), line.lastIndexOf('\t', max), line.lastIndexOf('-', max));
            const cut = space > 0 ? space : max;
            result.push(line.slice(0, cut).trimEnd());
            line = line.slice(space > 0 ? cut + 1 : cut).trimStart();
        }
        result.push(line);
    }
    return result.join('\n');
}
export function slugify(input) {
    return input
        .toString()
        .normalize('NFKD') // split accents from letters
        .replace(/[\u0300-\u036f]/g, '') // remove accents
        .toLowerCase()
        .replace(/&/g, ' and ')
        .replace(/[^a-z0-9]+/g, '-') // replace non-safe chars with hyphens
        .replace(/^-+|-+$/g, '') // remove leading/trailing hyphens
        .replace(/-{2,}/g, '-') // collapse repeated hyphens
        .trim();
}
//# sourceMappingURL=StringUtils.js.map